"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getCookie = getCookie;
exports.requestCurrentVersionInfo = requestCurrentVersionInfo;
exports.getUrlRoot = getUrlRoot;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");
/* eslint import/prefer-default-export:0 */


function getCookie(key) {
  var regExp = new RegExp("".concat(key.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'), "=([^;]*)"));
  var match = regExp.exec(document.cookie);
  var str = match && match[1];

  if (str) {
    // remove quote marks
    return str.replace(/"/g, '');
  }
}

function isValidUuid(uuid) {
  return /^[a-zA-Z0-9-_]*$/.exec(uuid);
}

function moduleCurrentVersionUrl(modulePath, env, options) {
  var root = 'https://api2.shutterfly.com/frontendci';
  return "".concat(root, "/app/").concat(modulePath, "/env/").concat(env, "/current-version");
}

function getUrlRootUncached(_x, _x2) {
  return _getUrlRootUncached.apply(this, arguments);
}

function _getUrlRootUncached() {
  _getUrlRootUncached = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(modulePath, options) {
    var pinnedVersionCookie, currentEnv, response, responseBody, contentRoot;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pinnedVersionCookie = getCookie("".concat(modulePath, "-versionUUID"));

            if (!(pinnedVersionCookie && isValidUuid(pinnedVersionCookie))) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", "https://frontend-ci.internal.shutterfly.com/prerelease-file/".concat(pinnedVersionCookie));

          case 3:
            _context.next = 5;
            return (0, _uigCdnLibraries.polyfillFetch)();

          case 5:
            currentEnv = options && options.currentEnv || (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();
            _context.next = 8;
            return fetch(moduleCurrentVersionUrl(modulePath, currentEnv, options));

          case 8:
            response = _context.sent;
            _context.next = 11;
            return response.json();

          case 11:
            responseBody = _context.sent;
            contentRoot = responseBody.rootUrl || responseBody.cdnRootUrl;

            if (contentRoot) {
              _context.next = 15;
              break;
            }

            throw new Error('missing .rootUrl from response');

          case 15:
            return _context.abrupt("return", contentRoot);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getUrlRootUncached.apply(this, arguments);
}

function requestCurrentVersionInfo(_x3, _x4) {
  return _requestCurrentVersionInfo.apply(this, arguments);
}

function _requestCurrentVersionInfo() {
  _requestCurrentVersionInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(modulePath, env) {
    var response;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(moduleCurrentVersionUrl(modulePath, env));

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.json());

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _requestCurrentVersionInfo.apply(this, arguments);
}

function getUrlRoot(_x5, _x6) {
  return _getUrlRoot.apply(this, arguments);
}

function _getUrlRoot() {
  _getUrlRoot = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(modulePath, options) {
    var cached, contentRoot;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            window.FrontendVersionUtil = window.FrontendVersionUtil || {};
            window.FrontendVersionUtil.contentRoots = window.FrontendVersionUtil.contentRoots || {};
            cached = window.FrontendVersionUtil.contentRoots[modulePath];

            if (!cached) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", cached);

          case 6:
            _context3.next = 8;
            return getUrlRootUncached(modulePath, options);

          case 8:
            contentRoot = _context3.sent;
            window.FrontendVersionUtil.contentRoots[modulePath] = contentRoot;
            return _context3.abrupt("return", contentRoot);

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0); // Something went wrong and we don't know the module's latest version.
            // Use an unversioned path, so that maybe the site might continue to work.

            window.console.error("uig-frontend-version-util failed, couldn't find the content " + "root for ".concat(modulePath, ". Using unversioned url. Error was: ").concat(_context3.t0));
            return _context3.abrupt("return", "https://cdn.staticsfly.com/".concat(modulePath));

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 13]]);
  }));
  return _getUrlRoot.apply(this, arguments);
}